// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pdfNotes-pdf-notes-wrapper-6WJ {\n    margin-bottom: 5px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.pdfNotes-pdf-notes-wrapper-6WJ p:last-of-type {\n    color: #424447;\n    max-width: 85%;\n    word-break: break-word;\n}\n\n.pdfNotes-pdf-notes-wrapper-6WJ p:first-of-type {\n    color: #232323;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pdf-notes-wrapper": "pdfNotes-pdf-notes-wrapper-6WJ"
};
export default ___CSS_LOADER_EXPORT___;
